import CommonService from "@/services/CommonService";
export default {
  data() {
    return {
      exchangeRates: {},
      prefered_currency: this.$store.state.user.prefered_currency
    };
  },
  beforeCreate() {
    CommonService.getexchangeRates().then(result => {
      this.exchangeRates = result.data;
      this.exchangeRates.USDUSD = 1;
    });
  },
  methods: {
    calculateTotalAmount(val) {
      if (!val) return "";
      const rates = this.exchangeRates;
      let amounts = val
        .map(
          e =>
            parseFloat(e.amount) +
            parseFloat(e.nomad_fee) +
            parseFloat(e.cleaning_fee)
        )
        .reduce((prev, curr) => prev + curr, 0);
      amounts = (
        (amounts * rates[`USD${this.prefered_currency}`]) /
        rates[`USD${val[0].currency_code}`]
      ).toFixed(2);
      return this.prefered_currency + " " + amounts;
    },
    calculateTotalPaidAmount(val) {
      if (!val) return "";
      const rates = this.exchangeRates;
      let amounts = val
        .map(e => {
          if (e.payment_status == "Paid") {
            return (
              parseFloat(e.amount) +
              parseFloat(e.nomad_fee) +
              parseFloat(e.cleaning_fee)
            );
          } else {
            return 0;
          }
        })
        .reduce((prev, curr) => prev + curr, 0);
      amounts = (
        (amounts * rates[`USD${this.prefered_currency}`]) /
        rates[`USD${val[0].currency_code}`]
      ).toFixed(2);
      return this.prefered_currency + " " + amounts;
    },
    calculateTotalUnpaidAmount(val) {
      if (!val) return "";
      const rates = this.exchangeRates;
      let amounts = val
        .map(e => {
          if (e.payment_status == "Unpaid") {
            return (
              parseFloat(e.amount) +
              parseFloat(e.nomad_fee) +
              parseFloat(e.cleaning_fee)
            );
          } else {
            return 0;
          }
        })
        .reduce((prev, curr) => prev + curr, 0);
      amounts = (
        (amounts * rates[`USD${this.prefered_currency}`]) /
        rates[`USD${val[0].currency_code}`]
      ).toFixed(2);
      return this.prefered_currency + " " + amounts;
    },
    currencyConversion(val, val1) {
      if (!val) return "";
      const rates = this.exchangeRates;
      let amount = (
        (parseFloat(val) * rates[`USD${this.prefered_currency}`]) /
        rates[`USD${val1}`]
      ).toFixed(2);
      return this.prefered_currency + " " + amount;
    },
    calculateNomadCleaningFee(val) {
      if (!val) return "";
      const rates = this.exchangeRates;
      let fees = parseFloat(val.nomad_fee) + parseFloat(val.cleaning_fee);
      let amount = (
        (fees * rates[`USD${this.prefered_currency}`]) /
        rates[`USD${val.currency_code}`]
      ).toFixed(2);
      return this.prefered_currency + " " + amount;
    }
  }
};
